export default __webpack_public_path__ + "static/media/gournay11.d3b9f1ab.jpg";